export const MARKER_PAYMENT_DETAIL_COLUMNS = [
    "EXAM CENTRE",
    "EXAM NUMBER",
    "SYLLABUS",
    "MODULE",
    "DATE",
    "CANDIDATES",
    "SCRIPTS"
]
